/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import { TeamMembershipRolePermissions } from '@fai/friendli-suite/features/common/team-membership-role';
import {
  ClientTeamMembershipRole,
  DedicatedSubplanTier,
} from '@fai/friendli-suite/generated/client/graphql';

export type DedicatedEndpointsProductPlan =
  | 'ACCESS_REQUIRED'
  | 'BASIC'
  | 'ENTERPRISE'
  | 'NONE_MEMBER'
  | 'NONE_OWNER';

interface DedicatedEndpointsPlanRawData {
  teamRole?: ClientTeamMembershipRole | null;
  isProductAccessible?: boolean | null;
  productPlan?: DedicatedSubplanTier | null;
}

export const convertRawDataToPlan = ({
  teamRole,
  isProductAccessible,
  productPlan,
}: DedicatedEndpointsPlanRawData): DedicatedEndpointsProductPlan => {
  const { isTeamOwner } = TeamMembershipRolePermissions(teamRole);

  let planResult: DedicatedEndpointsProductPlan = isTeamOwner ? 'NONE_OWNER' : 'NONE_MEMBER';

  if (productPlan === DedicatedSubplanTier.Basic) {
    // BASIC except user is member and inaccessible.
    planResult = isTeamOwner || isProductAccessible ? 'BASIC' : 'ACCESS_REQUIRED';
  }

  if (productPlan === DedicatedSubplanTier.Enterprise) {
    // ENTERPRISE except user is member and inaccessible.
    planResult = isTeamOwner || isProductAccessible ? 'ENTERPRISE' : 'ACCESS_REQUIRED';
  }

  return planResult;
};

export const getIsPlanInaccessible = (plan: DedicatedEndpointsProductPlan) =>
  ['ACCESS_REQUIRED', 'NONE_MEMBER', 'NONE_OWNER'].includes(plan);
